export function formatDatesInObject<T extends Record<string, any>>(obj: T): T {
    const result: Record<string, any> = {...obj};

    for (const key in result) {
        const value = result[key];

        if (typeof value === "string" && !isNaN(Date.parse(value))) {
            const date = new Date(value);
            result[key] = date.toISOString().split("T")[0];
        }
    }

    return result as T;
}
